/**
 * Placeholder YouTube URL для `<VideoButton>` на Экране 2.12.10 «КП».
 * Будет заменён на реальный embed когда продюсер запишет ролик-инструкцию
 * по составлению коммерческого предложения (B-008 / PRD §16.4).
 */
export const QUOTE_VIDEO_URL = 'https://www.youtube.com/embed/dQw4w9WgXcQ';
